// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';

import { cyan500, grey500 } from 'material-ui/styles/colors';

import LocationSearchField from 'components/LocationSearchField';
import LocaleSwitcher from 'components/LocaleSwitcher';
import SupportPopover from './SupportPopover';
import ProfileMenu from './ProfileMenu';

function getStyles(context) {
  const { appBar, zIndex } = context.muiTheme;

  return {
    root: {
      position: 'fixed',
      top: 0,
      zIndex: 1400,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
    },

    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: 0,
      paddingTop: 0,
      paddingLeft: appBar.padding,
      letterSpacing: 0,
      fontSize: 20,
      fontWeight: appBar.titleFontWeight,
      color: cyan500,
      height: appBar.height,
      lineHeight: `${appBar.height}px`,
      userSelect: 'none',
      position: 'relative',
    },

    logo: {
      height: 40,
      paddingRight: 16,
      verticalAlign: 'middle',
    },

    betaBadge: {
      position: 'absolute',
      top: 12,
      right: 0,
      background: 'orange',
      padding: 4,
      borderRadius: 3,
      color: 'white',
      fontSize: 10,
      lineHeight: '12px',
      fontFamily: 'Roboto Condensed, sans-serif',
    },

    mainItemContainer: {
      height: 48,
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end',
      alignItems: 'center',
      margin: 10,
    },

    iconButton: {
      color: cyan500,
    },
  };
}

export default class AppBar extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object.isRequired,
  };

  render() {
    const {
      browser,
      authTokenData,
      subscriptions,
      hasSubscription,

      hudOpen,
      toggleHUD,

      appInDrawMode,
      mobileLocationSearchShown,
      toggleMobileLocationSearch,

      toggleDrawMode,
      dndOverlaySetDndState,
    } = this.props;

    const isMobile = browser.lessThan.medium;
    const styles = getStyles(this.context);

    let logo = null;
    if (!mobileLocationSearchShown && !appInDrawMode) {
      logo =
        hudOpen && isMobile ? (
          <h1 className="intro-tour__step-0" style={styles.title}>
            Eseti légtér tervezése
          </h1>
        ) : (
          <h1 className="intro-tour__step-0" style={styles.title}>
            <a href="https://legter.hu">
              <img
                src="/assets/legter_logo.png"
                style={styles.logo}
                alt="légtér.hu"
              />
            </a>
          </h1>
        );
    }

    let rightButtons = [];

    if (mobileLocationSearchShown) {
      rightButtons = [
        <IconButton
          key="back"
          iconClassName="material-icons"
          iconStyle={styles.iconButton}
          onClick={() => toggleMobileLocationSearch(false)}
        >
          arrow_back
        </IconButton>,
        <LocationSearchField key="mobile-location-search" />,
      ];
    } else if (appInDrawMode) {
      rightButtons = [
        <IconButton
          key="back"
          iconClassName="material-icons"
          iconStyle={styles.iconButton}
          onClick={() => {
            dndOverlaySetDndState(null);
            toggleDrawMode(false);
            toggleHUD(true);
          }}
        >
          arrow_back
        </IconButton>,
        <h1 style={{ ...styles.title, flex: 1 }} key="draw-mode-title">
          Pontos terület kijelölése
        </h1>,
      ];
    } else {
      rightButtons = [
        <IconButton
          key="toggle-search"
          className="intro-tour__step-1"
          iconClassName="material-icons"
          iconStyle={styles.iconButton}
          onClick={() => toggleMobileLocationSearch(true)}
        >
          search
        </IconButton>,
      ];
    }

    const locationSearchContainer = (
      <div style={styles.mainItemContainer} key="location-search-container">
        {isMobile || appInDrawMode ? rightButtons : <LocationSearchField />}
      </div>
    );

    const closeHUD = (
      <div style={styles.mainItemContainer} key="close-hud-container">
        <IconButton
          key="close-hud"
          iconClassName="material-icons"
          iconStyle={styles.iconButton}
          onClick={() => toggleHUD(false)}
        >
          close
        </IconButton>
      </div>
    );

    const iconsOnRight = mobileLocationSearchShown
      ? [locationSearchContainer]
      : [
          locationSearchContainer,
          <ProfileMenu
            key="profile-menu"
            tokenData={authTokenData}
            subscriptions={subscriptions}
            hasSubscription={hasSubscription}
          />,
          <SupportPopover key="support-popover" />,
          <LocaleSwitcher key="locale-switcher" />,
        ];

    return (
      <Paper rounded={false} style={styles.root} zDepth={1}>
        {logo}
        {isMobile && this.props.hudOpen ? closeHUD : iconsOnRight}
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./components/AppBar/AppBar.js